import { render, staticRenderFns } from "./out_sourcing_progress_list.vue?vue&type=template&id=2c353c2a&scoped=true"
import script from "./out_sourcing_progress_list.vue?vue&type=script&lang=js"
export * from "./out_sourcing_progress_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c353c2a",
  null
  
)

export default component.exports